"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.unionFragment = void 0;
__exportStar(require("./generated/interfaces"), exports);
__exportStar(require("./generated/enums"), exports);
__exportStar(require("./core"), exports);
var fragments_1 = require("./static/fragments");
Object.defineProperty(exports, "unionFragment", { enumerable: true, get: function () { return fragments_1.unionFragment; } });
//# sourceMappingURL=browser.js.map